
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { MyImage } from '../../myImage'
import { CardDetail } from '../cardDetail'
import styles from '../css/normalCard.module.scss'
import moment from 'moment'
import { CardActions } from '../CardActions'
import { cardDataToUrl } from '../../../utils/cardData2Url'
import Link from 'next/link'
import { 
    faClock,
} from '@fortawesome/free-regular-svg-icons';
import Paper from '@mui/material/Paper'
import dynamic from 'next/dynamic'
import Image from 'next/image'
import { Box, Button, Chip, Grid, Typography, styled } from '@mui/material'
import { buildImageUrl } from '../../../utils/utils'
import RenderDetail, { getDetailList, iconMap } from '../../detail/renderDetail'
import { useTranslation } from 'react-i18next'
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import IosShareOutlinedIcon from '@mui/icons-material/IosShareOutlined';

import '@mui/material/styles';
import { isMobile, isTablet } from 'react-device-detect'
import { useTabletAndBelowMediaQuery } from '../../../utils/responsive'

declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    tablet: true;
    desktop: true;
    mdd: true;
    lgg: true;
    xl: true;
    assetCard: true;
    // You can also set existing breakpoints to `false` to remove them if needed
    // xs: false;
  }
}

const DynamicMyImage = dynamic(() => import('../../myImage')
  .then(module => module.MyImage), { 
        ssr: false, 
        loading: () => <div className={styles.cardImage}>Loading...</div> 
    })

export const NormalCard = ({
    onClick,
    onMouseDown,
    d,
    action,
    locale,
    t,
    name,
    imageUrl,
    imageurlfallback,
    location,
    popOverState,
    setPopOverState,
    inquiryState,
    setInquiryState,
    appointmentState,
    setAppointmentState,
    getPropertyPrice,
    language
}) => {
    return (
        <div key={d.property.id} className={styles.cardItem}>
        <Paper key={d.property.id} >
        <div className={styles.cardContainerOutter}>
            <div className={styles.cardHeader}>
                <div className={styles.cardImagecontainer}
                    // onClick={() => onClick(d)}
                    // onMouseDown={(e) => onMouseDown(e, d)}
                >
                    {
                        (d?.property?.boots_status === 1) ?
                            <div className={styles.exclusiveLabel}>ประกาศ Exclusive</div>
                            : undefined
                    }
                    <a href={`${cardDataToUrl(d, action, locale, t)}`} target='_blank'>
                        <DynamicMyImage className={styles.cardImage} alt={name || null} src={`${imageUrl}`} width="100%" height="100%"
                            imageurlfallback={`${imageurlfallback}`}
                            onError={function () {
                                console.log('image error xxxxxxxx')
                                // this.style.display='none';
                            }}
                        />
                    </a>
                </div>
            </div>
            <div className={styles.cardbody}>
                {/* <div className={styles.cardTitle}
                    onClick={() => onClick(d)}
                    onMouseDown={(e) => onMouseDown(e, d)}
                > */}
                    <div className={styles.cardmeta}>
                        <Link legacyBehavior className="nav-link" href={`${cardDataToUrl(d, action, locale, t)}`} itemProp="url" passHref>
                            <a target="_blank">{name}</a>
                        </Link>
                    </div>
                {/* </div> */}
                <div>
                    <p className={styles.cardlocationcontainer} >{location}</p>
                    {/* <p>
                                        { d.property && d.property.sales === 1 ? <Tag color="#f50">{t('ขาย')}</Tag>: undefined }
                                        { d.property && d.property.rent === 1 ? <Tag color="#87d068">{t('เช่า')}</Tag>: undefined }
                                    </p>  */}
                    <div className={styles.cardDetailContainer}>
                        <div className={styles.priceContainer} >
                            {
                                getPropertyPrice(d, t, locale)
                            }
                        </div>
                        {/* <p>{d.property_ID}</p> */}
                        {/* <div className={styles.category}>{d.project?.category?.name[locale.toUpperCase()] || ''}</div> */}
                        <div className={styles.detail}>
                            {/* {detail} */}
                            <CardDetail property={d.property} project={d.project}
                                carddetail={d.carddetail} action={action} t={t} locale={locale} />
                        </div>
                    </div>
                    <div className={styles.postUserContainer}>
                        <div className={styles.postuser}>
                            {/* <Avatar  size="small" icon={<UserOutlined />} style={{marginRight: '5px'}} /> */}
                            {`${d.user[`first_name_${language}`] || ''} ${d.user[`last_name_${language}`] || ''}`}
                        </div>
                        <div style={{ display: "flex", justifyContent: 'right', alignItems: 'center', flexFlow: '1 1 auto' }}>
                            <FontAwesomeIcon icon={faClock} size="xs" className={styles.detailIcon} />
                            <div className={styles.updatedate} >{`${moment(d.property?.update).fromNow()}`}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.cardActions}>
                {
                    CardActions({
                        id: d.property.id,
                        type: 'property',
                        locale,
                        popOverState,
                        setPopOverState,
                        inquiryState,
                        setInquiryState,
                        appointmentState,
                        setAppointmentState,
                        imageURL: imageUrl,
                        name: name,
                        details: d,
                    })
                }
            </div>
        </div>
        </Paper>
        </div>
    )
}


export const MainInfoRow = ({ icon, label, value, unit }: { icon?: any; label: string; value: any; unit?: string }) => {
    const { t } = useTranslation();
    const displayValue = value && value !== '-' ? value : t('-');
    const showUnit = value && value !== '-' && value !== t('-');
  
    return (
      <Box display="flex" 
        flexDirection="row" 
        alignItems="center" gap={1} 
        sx={{ padding: '0px'}} 
        >
        {icon && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: (theme) => theme.palette.grey[500],
              bgcolor: '#F5F5F6',
              borderRadius: '50%',
            }}
          >
            {icon}
          </Box>
        )}
        <Typography
            variant="body2"
            align="center"
            sx={{ 
                fontSize: { xs: '1.1rem', sm: '1.3rem' }, 
                color: 'primary.main', 
            }}
        >
          {displayValue} {showUnit ? unit : ''}
        </Typography>
        <Typography variant="body1" align="center" 
            sx={{ 
                fontSize: { xs: '14px' },
                display: '-webkit-box',
                WebkitLineClamp: 1,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis', 
            }}>
          {label}
        </Typography>
      </Box>
    );
};

const CardRenderDetail = ({ data, locale }) => {
    const { t } = useTranslation();
    debugger;
   
    const overrideUnit = {
        'bedroom': 'นอน',
        'bathroom': 'bath',
        'square meter': 'ตร.ม.',
        'livingroom': 'room',
        'car-unit': 'parking',
        'kitchenroom': 'room'
    } 

    const items = getDetailList(data?.type, data, t, locale)
    const topItems = items.slice(0, 5);
    
    return (
      <Box sx={{ width: '100%'}}>
        {/* MainInfoRow – แสดง 5 รายการแรก */}
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            my: 4,
            mt: 0,
            mb: 0
          }}
        >
          {topItems.map((item, index) => {
            const icon = iconMap({ fontSize: { xs: 21, sm: 21 } })[item.key];
            const label = t(overrideUnit[item.key] || item.key);
            return (
              <Box
                key={index}
                sx={{
                    my: 0,
                    mb: 2,
                    flex: '1 1 33.3333%',
                    maxWidth: '33.3333%',
                    '@media (min-width: 800px)': {
                        flex: '1 1 20%',
                        maxWidth: '20%',
                    },
                }}
              >
                <MainInfoRow icon={icon} label={label} value={item.value} unit={item.unit} 
                    
                />
              </Box>
            );
          })}
        </Box>
      </Box>
    );
  };


const MyGridStyle = styled(Grid)(({ theme }) => ({
    breakpoints: {
        values: {
            // xs: 0,
            assetCard: 548,
            // sm: 600,
            // md: 900,
            // tablet: 1024, // Your new custom breakpoint
            // lg: 1200,
            // desktop: 1440, // Another custom breakpoint
            // xl: 1536,
            
        },
    },
    [theme.breakpoints.down('assetCard')]: {
        backgroundColor: 'red',
    }
    // [theme.breakpoints.down('md')]: {
    //     padding: '6px 2px',
    //     minHeight: '50px',
    // },
    // [theme.breakpoints.down('sm')]: {
    //     padding: '4px 1px',
    //     minHeight: '45px',
    //     maxWidth: '160px',
    // },
}));

export const NormalCard3 = ({
    onClick,
    onMouseDown,
    d,
    action,
    locale,
    t,
    name,
    imageUrl,
    imageurlfallback,
    location,
    popOverState,
    setPopOverState,
    inquiryState,
    setInquiryState,
    appointmentState,
    setAppointmentState,
    getPropertyPrice,
    language
}) => {

    const isTabletAndBelow = useTabletAndBelowMediaQuery()
    
    let imageWidth = 480;
    let imageRatio =  4 / 3 ;
    let imageHeight = Math.round(imageWidth / imageRatio);

    // if(isTabletAndBelow) {
    //     imageWidth = 200;
    //     imageRatio =  4 / 3 ;
    //     imageHeight = Math.round(imageWidth / imageRatio);

    //     console.log('is Table')
    // }

    if(isMobile) {
        imageWidth = 375;
        imageRatio =  4 / 3 ;
        imageHeight = Math.round(imageWidth / imageRatio);

        console.log('is Table')
    }

    return (
            <Paper key={d.property.id} style={{borderRadius: '10px'}}>
                <Grid container spacing={1} className='grid1'>
                    <Grid container item xs={12} md={5} mdd={5} lg={5} >
                        {/* {
                            (d?.property?.boots_status === 1) ?
                                <div className={styles.exclusiveLabel}>ประกาศ Exclusive</div>
                                : undefined
                        } */}
                      
                        <a href={`${cardDataToUrl(d, action, locale, t)}`} target='_blank'
                        style={{height: '0px !importanct'}}>
                            <DynamicMyImage alt={name || null} src={`${imageUrl}`} 
                                width={`${imageWidth}`}
                                height={`${imageHeight}`}
                                imageurlfallback={`${imageurlfallback}`}
                                imagestyle={styles.cardImage}
                                onError={function () {
                                    console.log('image error xxxxxxxx')
                                }}
                            />
                        </a>
                    </Grid>
                    
                    <Grid container item xs={12} md={7} mdd={7} lg={7} 
                        style={{
                            paddingLeft: '20px',
                            paddingRight: '20px',
                            paddingTop: '10px',
                            paddingBottom: '10px',
                            boxSizing: 'border-box'
                        }}
                    >
                            <MyGridStyle item xs={12} 
                                gap={2}
                                style={{
                                    fontFamily: 'Prompt, sans-serif',
                                    display: 'flex', flexDirection: 'row', 
                                    justifyContent: 'flex-start', 
                                    // alignItems: 'center',
                                    color: 'grey'
                                }}
                            >
                                <div>{d.property.property_code}</div>
                                <Box display={"flex"} flexDirection="row" alignItems="center" gap={1}>
                                    <FontAwesomeIcon icon={faClock} size="xs" className={styles.detailIcon} />
                                    <div className={styles.updatedate} >{`${moment(d.property?.update).fromNow()}`}</div>
                                </Box>

                                <Box sx={{ flexGrow: 1 }}
                                    display={'flex'}
                                    justifyContent={'flex-end'}
                                    alignItems={'center'}
                                    gap={2}
                                >
                                    <FavoriteBorderIcon sx={{height: '23px'}}/>
                                    <IosShareOutlinedIcon sx={{height: '23px'}}/>
                                </Box>
                            </MyGridStyle>

                            <Grid item xs={12}
                                style={{padding: '0px', margin: '0px'}}
                            >
                                <div className={styles.priceContainer} >
                                    {
                                        getPropertyPrice(d, t, locale)
                                    }
                                </div>
                            </Grid>

                            
                            <Grid item xs={12} 
                                gap={1}
                                style={{display: 'flex', flexDirection: 'row', padding: '0px'}}
                            >
                                <Box>
                                    {
                                        d?.project?.project_logo? 
                                        <Image src={
                                            buildImageUrl({
                                                galleryPath: 'project_image',
                                                pathId: d?.project?.project_ID,
                                                fileName: d?.project?.project_logo
                                              })
                                        } alt="location" width={48} height={48} />
                                        :   
                                        <DynamicMyImage alt={name || null} src={`${imageUrl}`} 
                                            width="48" 
                                            height="48"
                                            imageurlfallback={`${imageurlfallback}`}
                                            imagestyle={styles.cardImage}
                                            onError={function () {
                                                console.log('image error xxxxxxxx')
                                            }}
                                        />
                                    }
                                    
                                </Box>
                                <Box display={'flex'} flexDirection={'column'} style={{width: '100%'}} >
                                    <Typography
                                        sx={{
                                            width: '100%',
                                            padding: 0,
                                            fontSize: { xs: '18px' },
                                            color: 'black',
                                            display: '-webkit-box',
                                            WebkitLineClamp: 1,
                                            WebkitBoxOrient: 'vertical',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                        }}
                                    >
                                        {d?.project?.name[`${locale.toUpperCase()}`]}
                                    </Typography>
                                    <div style={{display: 'flex', flexDirection: 'row'}}>
                                        {/* <CardDetail property={d.property} project={d.project}
                                            carddetail={d.carddetail} action={action} t={t} locale={locale} /> */}

                                        <CardRenderDetail data={
                                            {
                                                type: d.project?.category?.name?.EN,
                                                ...d
                                            }
                                        } locale={locale} />
                                    </div>
                                </Box> 
                            </Grid>

                            <Grid container item xs={12} style={{padding: 0}}>
                                <Grid item xs={12} >
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            padding: '0px',
                                            margin: '0px',
                                            fontSize: { xs: '18px', sm: '18px' },
                                            fontWeight: 'bold',
                                            color: '#575758',
                                            display: '-webkit-box',
                                            WebkitLineClamp: 1,
                                            WebkitBoxOrient: 'vertical',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                        }}>{name}</Typography>
                                </Grid>
                                <Grid item xs={12} >    
                                    <Typography
                                            variant="body2"
                                            sx={{
                                                padding: 0,
                                                fontSize: { xs: '12px' },
                                                color: '#575758',
                                                display: '-webkit-box',
                                                WebkitLineClamp: 1,
                                                WebkitBoxOrient: 'vertical',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                            }}
                                            >
                                        { d.property.additional || '-'} </Typography>
                                    {/* </Box> */}
                                </Grid>
                            </Grid>
                            
                            
                            <Grid container item xs={12} 
                                gap={1}
                                sx={{
                                    paddingTop: '10px',
                                }}
                            >
                                <Image src="/assets/map.png" alt="location" width={48} height={48} />
                                <Typography sx={{ fontSize: { xs: '12px'}}}>
                                    {location}
                                </Typography>
                            </Grid>
                            

                            <Grid container item xs={12}
                                flexDirection={'row'}
                                justifyContent={'space-between'}
                                alignItems={'center'}
                                style={{
                                    paddingLeft: '0'
                                }}
                                >
                                <Grid item xs={12} md>
                                    <Box 
                                        display="flex" 
                                        flexWrap="wrap" gap={1} 
                                        justifyContent={'flex-start'}>
                                        {
                                            d?.property?.specials.map((special, index) => (
                                                <div key={index}>
                                                    <Chip size="small" 
                                                        label={t(special[`name_${locale.toUpperCase()}`])}
                                                        style={{borderRadius: '4px'}}
                                                    ></Chip>
                                                </div>
                                            ))
                                        }
                                    </Box>
                                </Grid>

                                <Grid item xs={12} md={3} className={styles.cardButtonContainer}>
                                    <Button className={styles.cardButton}
                                        variant="contained"  
                                        >{t('bottomMenu.contact')}</Button>
                                </Grid>
                            </Grid>
                           
                            {/* <div className={styles.postUserContainer}>
                                <div className={styles.postuser}>
                                    {`${d.user[`first_name_${language}`] || ''} ${d.user[`last_name_${language}`] || ''}`}
                                </div>
                            </div> */}
                    </Grid>
                    
                </Grid>
            </Paper>
    )
}